import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconBlackpoint: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconBlackpoint"><Path d="M21.5 12C21.5 17.2467 17.2467 21.5 12 21.5C6.75329 21.5 2.5 17.2467 2.5 12C2.5 6.75329 6.75329 2.5 12 2.5C17.2467 2.5 21.5 6.75329 21.5 12Z" stroke="currentColor"/><Circle cx="12" cy="12" r="2.5" stroke="currentColor"/><Circle cx="12" cy="12" r="1.5" stroke="currentColor"/><Circle cx="12" cy="12" r="0.5" stroke="currentColor"/></CentralIconBase>;
});

export default IconBlackpoint;
